// Copyright © 2021 Move Closer

import { AnyObject } from '@movecloser/front-core'

import { Identifier, Related, RelatedType } from '../../services/related'

import { Addon, AddonData, ContentAddons, ContentSneakPeakAddons } from './addons'
import { AnyModule } from './modules'
import { Author } from './author'
import { TreeNodeParent } from './tree-node'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
interface BaseContent {
  categoryUrl?: string;
  id: Identifier;
  parent?: TreeNodeParent;
  publicationDate: string;
  site: Identifier;
  title: string;
  type: ContentType;
  fullUrl?: string;
  urlPath: string;
  commentsCount: number;
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ContentData extends BaseContent {
  author: Related<RelatedType.Author>;
  contentProperties: AnyObject;
  containers: Record<LayoutContainer, LayoutContainerType>;
  contentId: Identifier;
  options: ContentOptions;
  slots: Record<LayoutSlot, AnyModule[]>;
  properties: Partial<Record<ContentAddons, AddonData>>;
}

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export interface ContentOptions {
  [key: string]: boolean;
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ContentSneakPeakData extends BaseContent {
  author: Author;
  paywall: boolean;
  properties: Partial<Record<ContentSneakPeakAddons, AddonData>>;
  sponsored: boolean;
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 * @author Michał Wawer <michal.wawer@movecloser.pl>
 */
export enum ContentType {
  Article = 'article',
  Landing = 'landing',
  LiveArticle = 'live_article',
  Page = 'page',
  SmartPage = 'smart_page',
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface IContent {
  get<T> (property: string, defaultValue?: T): T;

  getOption (key: string, defaultValue?: boolean): boolean;

  getProperty (addon: Addon): AddonData;

  hasProperty (addon: Addon): boolean;
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum LayoutContainer {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top'
}

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum LayoutContainerType {
  Boxed = 'boxed',
  FullWidth = 'full-width'
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export enum LayoutSlot {
  Bottom = 'bottom',
  Left = 'left',
  Main = 'main',
  Right = 'right',
  Top = 'top',
  Comments = 'comments'
}
